mutation UpdatePoll(
  $pollId: ID!
  $name: String
  $broadcasterUserIds: [String!]
  $question: String
  $options: [StreamToolsPollOptionInput!]
  $dedupe: Boolean
  $callToActionText: String
  $headingTextColor: String
  $optionsTextColor: String
  $callToActionTextColor: String
  $headingBackground: String
  $optionsBackground: String
  $callToActionBackground: String
  $alternatingOptionBackground: String
  $backgroundImage: String
  $backgroundImageFit: StreamToolsImageFit
  $cornerRadius: Int
  $borderWidth: Int
  $borderColor: String
  $winnerOutlineColor: String
  $fontKey: String
  $youtubeVotesEnabled: Boolean
  $closeGraceSeconds: Int
  $template: StreamToolsPollTemplate
  $tickerLabel: String
  $ctaSubtext: String
  $tickerTextSize: StreamToolsTickerTextSize
  $tickerBlockWeights: [Float!]
  $questionFontSize: Int
  $tickerLabelFontSize: Int
  $displayTextFontSize: Int
  $commandFontSize: Int
  $numberFontSize: Int
  $callToActionFontSize: Int
  $closedTextFontSize: Int
  $tickerHeight: Int
) {
  poll: StreamToolsUpdatePoll(
    pollId: $pollId
    name: $name
    broadcasterUserIds: $broadcasterUserIds
    question: $question
    options: $options
    dedupe: $dedupe
    callToActionText: $callToActionText
    headingTextColor: $headingTextColor
    optionsTextColor: $optionsTextColor
    callToActionTextColor: $callToActionTextColor
    headingBackground: $headingBackground
    optionsBackground: $optionsBackground
    callToActionBackground: $callToActionBackground
    alternatingOptionBackground: $alternatingOptionBackground
    backgroundImage: $backgroundImage
    backgroundImageFit: $backgroundImageFit
    cornerRadius: $cornerRadius
    borderWidth: $borderWidth
    borderColor: $borderColor
    winnerOutlineColor: $winnerOutlineColor
    fontKey: $fontKey
    youtubeVotesEnabled: $youtubeVotesEnabled
    closeGraceSeconds: $closeGraceSeconds
    template: $template
    tickerLabel: $tickerLabel
    ctaSubtext: $ctaSubtext
    tickerTextSize: $tickerTextSize
    tickerBlockWeights: $tickerBlockWeights
    questionFontSize: $questionFontSize
    tickerLabelFontSize: $tickerLabelFontSize
    displayTextFontSize: $displayTextFontSize
    commandFontSize: $commandFontSize
    numberFontSize: $numberFontSize
    callToActionFontSize: $callToActionFontSize
    closedTextFontSize: $closedTextFontSize
    tickerHeight: $tickerHeight
  ) {
    pollId
    eventId
    name
    broadcasterUserIds
    question
    status
    dedupe
    youtubeVotesEnabled
    totalVotes
    closeGraceSeconds
    graceEndsAt
    youtubeCountsPurgedAt
    startedAt
    stoppedAt
    createdAt
    callToActionText
    headingTextColor
    optionsTextColor
    callToActionTextColor
    headingBackground
    optionsBackground
    callToActionBackground
    alternatingOptionBackground
    backgroundImage
    backgroundImageFit
    cornerRadius
    borderWidth
    borderColor
    winnerOutlineColor
    fontKey
    template
    tickerLabel
    ctaSubtext
    tickerTextSize
    tickerBlockWeights
    questionFontSize
    tickerLabelFontSize
    displayTextFontSize
    commandFontSize
    numberFontSize
    callToActionFontSize
    closedTextFontSize
    tickerHeight
    version
    options {
      optionId
      displayText
      command
      voteCount
      voteCountByPlatform { twitch youtube }
      textColor
      progressBarColor
      backgroundColor
    }
  }
}
